module.exports = __webpack_public_path__ + "img/microsoft.82521377.svg";